import { SellerServiceAssociation } from "../../domain/entities/ServiceSellerAssociation"

interface ConstructorParams {
	sellerId: number
	serviceId?: number | null
	feePercentage: number
}

export class SellerServiceAssociationModel {
	public sellerId: number
	public serviceId?: number | null
	public feePercentage: number

	constructor(params: ConstructorParams) {
		this.sellerId = params.sellerId
		this.serviceId = params.serviceId
		this.feePercentage = params.feePercentage
	}

	static fromRawJson = (rawJson: any): SellerServiceAssociationModel => {
		const { feePercentage, serviceId, sellerId } = rawJson
		return new SellerServiceAssociationModel({
			sellerId,
			serviceId,
			feePercentage
		})
	}

	static fromDomain = (association: SellerServiceAssociation): SellerServiceAssociationModel => {
		return new SellerServiceAssociationModel({ ...association })
	}
}

declare module "./SellerServiceAssociationModel" {
	interface SellerServiceAssociationModel {
		toDomain(): SellerServiceAssociation
	}
}

SellerServiceAssociationModel.prototype.toDomain = function (): SellerServiceAssociation {
	const data = this
	return new SellerServiceAssociation({ ...data })
}
